import { createContext } from "react";

const SegmentContext = createContext(undefined);

export default SegmentContext;
